import { useCallback, useEffect, useState } from "react";
import { RefreshCw, ShieldCheck } from "lucide-react";
import { Input } from "../ui/input";
import { api } from "../../lib/api";

export const useHumanCheck = (testPrefix) => {
  const [challenge, setChallenge] = useState(null);
  const [answer, setAnswer] = useState("");
  const [website, setWebsite] = useState("");
  const [failed, setFailed] = useState(false);

  const refresh = useCallback(() => {
    setAnswer("");
    setFailed(false);
    api.get("/challenge").then((r) => setChallenge(r.data)).catch(() => { setChallenge(null); setFailed(true); });
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  // Get a new question only when the server may have used up the current one.
  const handleError = (err) => {
    const status = err?.response?.status;
    const detail = String(err?.response?.data?.detail || "");
    if (!status || status >= 500 || /verification|question|quickly|rejected|unsupported file|larger than 5 MB|does not look like/i.test(detail)) refresh();
  };

  const payload = { challenge_token: challenge?.token || "", challenge_answer: answer, website };
  const ui = (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 p-4" data-testid={`${testPrefix}-human-check`}>
      <ShieldCheck className="h-5 w-5 shrink-0 text-leaf" />
      <span className="text-sm font-semibold text-navy">Verify you're human: <span data-testid={`${testPrefix}-human-question`}>{challenge?.question || (failed ? "Could not load the question. Tap retry." : "Loading…")}</span></span>
      <Input required inputMode="numeric" maxLength={3} value={answer} onChange={(e) => setAnswer(e.target.value)} className="h-10 w-20 bg-white" aria-label="Verification answer" data-testid={`${testPrefix}-human-answer`} />
      <button type="button" onClick={refresh} className="rounded-md p-1.5 text-slate-500 hover:bg-white" aria-label="New question" title="New question / retry" data-testid={`${testPrefix}-human-refresh`}><RefreshCw className="h-4 w-4" /></button>
      <input type="text" name="itef_hp_contact_ref" tabIndex={-1} autoComplete="new-password" data-lpignore="true" data-1p-ignore="true" value={website} onChange={(e) => setWebsite(e.target.value)} className="absolute left-[-9999px] h-0 w-0 opacity-0" aria-hidden="true" />
    </div>
  );
  return { payload, refresh, handleError, ui };
};
